<template>
    <v-container>
        <editionsComparison />
    </v-container>
</template>

<script>

import editionsComparison from "@/components/admin/editions/editionsComparison";
export default {
    name: 'AdminEditionsComparison',
    components: { editionsComparison }
}
</script>

<style scoped>

</style>
